export default __webpack_public_path__ + "static/media/twinbed1.ef02e403.jpg";